
import { useState } from 'react';
import Hero from './components/Hero';
import FreshFish from './components/FreshFish';
import GrilledFish from './components/GrilledFish';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Cart from './components/Cart';

export default function Home() {
  const [cartItems, setCartItems] = useState<Array<{
    id: string;
    name: string;
    price: number;
    quantity: number;
    image: string;
  }>>([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [cartType, setCartType] = useState<'fresh' | 'grilled'>('fresh');
  const [showNotification, setShowNotification] = useState(false);
  const [addedProductName, setAddedProductName] = useState('');
  const [showOrderSentPopup, setShowOrderSentPopup] = useState(false);

  const addToCart = (item: { id: string; name: string; price: number; image: string }, type: 'fresh' | 'grilled') => {
    setCartItems(prev => {
      const existing = prev.find(i => i.id === item.id);
      if (existing) {
        return prev.map(i => 
          i.id === item.id ? { ...i, quantity: i.quantity + 1 } : i
        );
      }
      return [...prev, { ...item, quantity: 1 }];
    });
    setCartType(type);
    
    // Afficher la notification
    setAddedProductName(item.name);
    setShowNotification(true);
    setTimeout(() => {
      setShowNotification(false);
    }, 3000);
  };

  const updateQuantity = (id: string, quantity: number) => {
    if (quantity === 0) {
      setCartItems(prev => prev.filter(item => item.id !== id));
    } else {
      setCartItems(prev => prev.map(item => 
        item.id === id ? { ...item, quantity } : item
      ));
    }
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const handleOrderSent = () => {
    setIsCartOpen(false);
    clearCart();
    setShowOrderSentPopup(true);
    setTimeout(() => {
      setShowOrderSentPopup(false);
    }, 5000);
  };

  return (
    <div className="min-h-screen bg-white">
      <Hero cartCount={cartItems.reduce((sum, item) => sum + item.quantity, 0)} onCartClick={() => setIsCartOpen(true)} />
      <FreshFish onAddToCart={(item) => addToCart(item, 'fresh')} />
      <GrilledFish onAddToCart={(item) => addToCart(item, 'grilled')} />
      <About />
      <Contact />
      <Footer />
      <Cart 
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
        items={cartItems}
        onUpdateQuantity={updateQuantity}
        onClear={clearCart}
        isFreshFish={cartType === 'fresh'}
        onOrderSent={handleOrderSent}
      />
      
      {/* Notification ajout au panier */}
      <div 
        className={`fixed top-20 right-4 sm:right-6 bg-teal-600 text-white px-4 sm:px-6 py-3 sm:py-4 rounded-xl shadow-2xl flex items-center gap-3 z-50 transition-all duration-300 ${
          showNotification ? 'translate-x-0 opacity-100' : 'translate-x-[120%] opacity-0'
        }`}
      >
        <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
          <i className="ri-check-line text-lg sm:text-xl"></i>
        </div>
        <div className="min-w-0">
          <p className="font-semibold text-sm sm:text-base whitespace-nowrap">Ajouté au panier !</p>
          <p className="text-xs sm:text-sm text-teal-50 truncate max-w-[200px] sm:max-w-[250px]">{addedProductName}</p>
        </div>
      </div>

      {/* Popup commande envoyée */}
      {showOrderSentPopup && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl p-6 sm:p-8 max-w-md w-full text-center shadow-2xl animate-pulse">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-whatsapp-line text-3xl sm:text-4xl text-green-600"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">Commande envoyée !</h3>
            <p className="text-gray-600 mb-6">
              Votre commande a été envoyée pour finalisation via WhatsApp. Nous vous contacterons très bientôt pour confirmer les détails.
            </p>
            <button
              onClick={() => setShowOrderSentPopup(false)}
              className="bg-teal-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Compris !
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
